import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../constants/app';
import { checkForUniqueness } from '../../api/user';
import { extractJSON } from '../../services/jsonUtil';
import { getItem } from '../../utils/cache';
import { APP_ROUTES, getRoute } from '../../route';
import DeleteAccount from './DeleteAccount';

function getInitialValue(user) {
  const userLocal = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const SocialLoginData = extractJSON('SocialLoginData');

  const initialValues = {
    email: '',
    countryCode: '',
    mobile: '',
  };

  initialValues.email =
    user?.attributes?.email || userLocal?.attributes?.email || '';
  initialValues.countryCode =
    user?.attributes?.country_code ||
    userLocal?.attributes?.country_code ||
    SocialLoginData?.country_code ||
    '';
  initialValues.mobile =
    user?.attributes?.mobile || userLocal?.attributes?.mobile || '';
  return initialValues;
}

export const checkUniqueEmail = async email => {
  try {
    const data = {
      type: 'email',
      email,
    };
    const response = await checkForUniqueness(data);
    return response.data;
  } catch (error) {
    return error?.response?.data?.response?.errors[0] || error?.message;
  }
};

const formatPhoneDisplay = (countryCode, mobile) => {
  if (!mobile) return '';
  const code = countryCode || '';
  return `${code} ${mobile}`.trim();
};

const PersonalDetails = props => {
  const { user } = props;
  const history = useHistory();
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);

  const sessionData = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
  const urlParams = new URLSearchParams(window.location.search);
  const provider = urlParams.get('provider') || sessionData?.provider;
  const isAppleLogin = getItem('isAppleLogin');
  const isGoogleLinked = provider === 'google';
  const isSocialLogin = isGoogleLinked || isAppleLogin;
  const hasPhone = Boolean(user?.attributes?.mobile);
  const emailDisplay = getInitialValue(user).email;

  const handleChangeEmail = () => {
    const url = getRoute(APP_ROUTES.PROFILE_WITH_SUB_ROUTES, {
      pathParam: { section: 'change-email' },
    });
    history.push(url);
  };

  const handleChangePhone = () => {
    const url = getRoute(APP_ROUTES.PROFILE_WITH_SUB_ROUTES, {
      pathParam: { section: 'change-phone' },
    });
    history.push(url);
  };

  const handleChangePassword = () => {
    const url = getRoute(APP_ROUTES.PROFILE_WITH_SUB_ROUTES, {
      pathParam: { section: 'change-password' },
    });
    history.push(url);
  };

  const phoneDisplay = formatPhoneDisplay(
    user?.attributes?.country_code,
    user?.attributes?.mobile,
  );

  return (
    <div className="profile-form-div-outer">
      <div className="profile-form-div account-settings">
        <h2 className="account-settings-title">Account Settings</h2>
        <div>
          <div className="account-settings-field">
            <label className="account-settings-label" htmlFor="account-email">
              EMAIL ADDRESS
            </label>
            <div className="account-settings-input-row">
              <span className="account-settings-value" id="account-email">
                {emailDisplay}
              </span>
              {isGoogleLinked ? (
                <div className="account-settings-linked">
                  <img
                    src={IMAGE_CONSTANT.googleIcon}
                    alt="Google"
                    className="account-settings-google-icon"
                  />
                  <span>Linked</span>
                </div>
              ) : (
                <button
                  type="button"
                  className="account-settings-action"
                  onClick={handleChangeEmail}
                >
                  CHANGE &gt;
                </button>
              )}
            </div>
          </div>

          {hasPhone && (
            <div className="account-settings-field">
              <label className="account-settings-label">PHONE NUMBER</label>
              <div className="account-settings-input-row">
                <span className="account-settings-value">{phoneDisplay}</span>
                <button
                  type="button"
                  className="account-settings-action"
                  onClick={handleChangePhone}
                >
                  CHANGE &gt;
                </button>
              </div>
            </div>
          )}

          {!isSocialLogin && (
            <div className="account-settings-field">
              <label className="account-settings-label">PASSWORD</label>
              <div className="account-settings-input-row">
                <span className="account-settings-value account-settings-password">
                  ••••••••••••
                </span>
                <button
                  type="button"
                  className="account-settings-action"
                  onClick={handleChangePassword}
                >
                  CHANGE &gt;
                </button>
              </div>
            </div>
          )}

          <button
            type="button"
            className="account-settings-delete-btn"
            onClick={() => setShowDeleteAccount(true)}
          >
            Delete Account
          </button>
        </div>
      </div>
      <DeleteAccount
        show={showDeleteAccount}
        handleClose={() => setShowDeleteAccount(false)}
        userId={user?.id}
      />
    </div>
  );
};

PersonalDetails.propTypes = {
  user: PropTypes.object.isRequired,
};

export default PersonalDetails;
